import React, { Component } from 'react';
import { connect } from 'react-redux';
import { tiendaObtener, tiendaActualizarGeneral } from '../../store/actions';
import { Regex, RegexExtra, Validate } from '../../other';
import { Grid } from '@material-ui/core';
import {
  InputUI,
  ButtonUI,
  AlertUI,
  ModuleTitleUI,
  ModuleButtonBoxUI,
  CardModuleUI,
} from '../common';
import { WrapperLayout } from '../../layouts/WrapperLayout';

class General_ extends Component {
  state = {
    general: {
      t_nombre: {
        auth: false,
        validate: true,
        required: true,
        disabled: false,
        error: false,
        type: 'text',
        label: 'Nombre de la tienda',
        id: 't_nombre',
        name: 't_nombre',
        change_param: 'general',
        regex: Regex.NOMBRE_TIENDA,
        value: '',
        default_value: '',
        placeholder: 'Mi marca',
        messages: {
          help: 'Nombre de tu negocio',
          error: 'Por favor, ingrese un nombre de tienda válido',
          error_extra: RegexExtra.NOMBRE_TIENDA,
        },
      },
      t_email: {
        auth: false,
        validate: true,
        required: true,
        disabled: false,
        error: false,
        type: 'text',
        label: 'Email de la tienda',
        id: 't_email',
        name: 't_email',
        change_param: 'general',
        regex: Regex.EMAIL,
        value: '',
        default_value: '',
        placeholder: 'mimarca@algo.com',
        messages: {
          error: 'Por favor, ingrese un email válido',
          help: 'Email donde te llegarán todas las notificaciones de la tienda y utilizarás para iniciar sesión a tu panel',
          error_extra: RegexExtra.EMAIL,
        },
      },
      t_direccion: {
        auth: true,
        validate: true,
        required: false,
        disabled: false,
        error: false,
        type: 'text',
        label: 'Dirección de la tienda',
        id: 't_direccion',
        name: 't_direccion',
        change_param: 'general',
        regex: Regex.DIRECCION_4_65,
        value: '',
        default_value: '',
        placeholder: 'Mi dirección 1234, Rosario, Santa Fe',
        messages: {
          error: 'Por favor, ingrese una dirección de tienda válida',
          help: 'Aparecerá en la parte inferior de tu tienda',
          error_extra: RegexExtra.DIRECCION_4_65,
        },
      },
      t_telefono: {
        auth: true,
        validate: true,
        required: false,
        disabled: false,
        error: false,
        type: 'text',
        label: 'Teléfono de la tienda',
        id: 't_telefono',
        name: 't_telefono',
        change_param: 'general',
        regex: Regex.TELEFONO,
        value: '',
        default_value: '',
        placeholder: '0123456789',
        messages: {
          error: 'Por favor, ingrese un número de teléfono válido',
          help: 'Aparecerá en la parte inferior de tu tienda',
          error_extra: RegexExtra.TELEFONO,
        },
      },
    },
    loading: {
      general: true,
      error: false,
    },
    forms: {
      general: false,
    },
    alert: {
      open: false,
      type: 'error',
      message: '',
    },
  };

  componentDidMount() {
    this.props.tiendaObtener((err, resp) => {
      if (err) {
        this.setState({
          loading: {
            ...this.state.loading,
            general: false,
            error: true,
          },
        });
      } else {
        Validate.cargar_formulario_sin_nulos(
          this.props.tienda,
          this.state.general,
          (general_obj) => {
            this.setState({
              general: general_obj,
              loading: {
                ...this.state.loading,
                general: false,
                error: false,
              },
            });
          }
        );
      }
    });
  }

  handleChange = (e, blur, aditional) => {
    let value = e.target.value;
    let name = e.target.name;

    this.setState(
      {
        [aditional]: {
          ...this.state[aditional],
          [name]: {
            ...this.state[aditional][name],
            value: value,
          },
        },
      },
      () => {
        Validate.validate_input(this.state[aditional][name], blur, (input) => {
          this.setState({
            [aditional]: {
              ...this.state[aditional],
              [name]: input,
            },
          });
        });
      }
    );
  };

  handleCloseAlert = () => {
    this.setState({
      alert: {
        ...this.state.alert,
        open: false,
      },
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    this.setState({
      forms: {
        ...this.state.forms,
        general: true,
      },
    });

    let form = this.state.general;

    if (Validate.validar_formulario(form)) {
      this.props.tiendaActualizarGeneral(
        {
          t_nombre: form.t_nombre.value,
          t_email: form.t_email.value,
          t_direccion: form.t_direccion.value,
          t_telefono: form.t_telefono.value,
        },
        (err, resp) => {
          this.setState({
            forms: {
              ...this.state.forms,
              general: false,
            },
            alert: {
              ...this.state.alert,
              open: true,
              message: resp.message,
              type: err ? 'error' : 'success',
            },
          });
        }
      );
    } else {
      Validate.validar_formulario_actualizar_obj(form, (new_form) => {
        this.setState({
          forms: {
            ...this.state.forms,
            general: false,
          },
          general: new_form,
        });
      });
    }
  };

  render() {
    return (
      <WrapperLayout
        loading={this.state.loading.general}
        error={this.state.loading.error}
      >
        <AlertUI
          open={this.state.alert.open}
          message={this.state.alert.message}
          type={this.state.alert.type}
          handleCloseAlert={this.handleCloseAlert}
        />
        <Grid container spacing={24}>
          <Grid item xs={12}>
            <form onSubmit={this.handleSubmit}>
              <ModuleTitleUI title="Configuraciones generales" />
              <CardModuleUI>
                <Grid container spacing={24}>
                  <Grid item xs={12}>
                    <InputUI
                      handleChange={this.handleChange}
                      input={this.state.general.t_nombre}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <InputUI
                      handleChange={this.handleChange}
                      input={this.state.general.t_email}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <InputUI
                      handleChange={this.handleChange}
                      input={this.state.general.t_direccion}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <InputUI
                      handleChange={this.handleChange}
                      input={this.state.general.t_telefono}
                    />
                  </Grid>
                </Grid>
              </CardModuleUI>
              <ModuleButtonBoxUI>
                <ButtonUI
                  type="submit"
                  label="GUARDAR"
                  isLoading={this.state.forms.general}
                />
              </ModuleButtonBoxUI>
            </form>
          </Grid>
        </Grid>
      </WrapperLayout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    tienda: state.tienda,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    tiendaObtener: (callback) => dispatch(tiendaObtener(callback)),
    tiendaActualizarGeneral: (data, callback) =>
      dispatch(tiendaActualizarGeneral(data, callback)),
  };
};

export const General = connect(mapStateToProps, mapDispatchToProps)(General_);
